import React, { useState } from 'react';
import Modal from '@material-ui/core/Modal';
import { Close } from '@material-ui/icons';
import Typography from 'Components/Atoms/Typography';
import { PRODUCT_OVERLAY_PROPS } from './overlay';

type Props = {
  /** Hidden but available products; the tiles keep their PIN protection. */
  productIds: string[];
  /** onActivated runs once the product really opens (after its PIN). */
  renderProduct: (id: string, onActivated: () => void) => React.ReactNode;
};

const ProductFolder = ({ productIds, renderProduct }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="product-folder">
      <button
        type="button"
        className="product-folder-button"
        aria-haspopup="dialog"
        aria-label={`Mehr anzeigen (${productIds.length})`}
        onClick={() => setOpen(true)}
      >
        Mehr anzeigen
      </button>
      <Modal {...PRODUCT_OVERLAY_PROPS} open={open} onClose={() => setOpen(false)}>
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Weitere Produkte"
          className="product-folder-sheet"
          tabIndex={-1}
        >
          <div className="product-folder-header">
            <Typography variant="h5" translation={null}>
              Weitere Produkte
            </Typography>
            <button
              type="button"
              className="product-overlay-round-button"
              aria-label="Schließen"
              onClick={() => setOpen(false)}
            >
              <Close fontSize="small" />
            </button>
          </div>
          <div className="product-icons product-folder-grid">
            {productIds.map((id) => renderProduct(id, () => setOpen(false)))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ProductFolder;
